import React, { useState } from 'react';
import {
  Card, CardTitle, CardContent, CardHeader, CardGradientText,
} from '@/components/overseaHome/ui/Card';
import type { OverseaFeatureItem } from '@/apiSdk/api.type';
import useIsClient from '@/hooks/useIsClient';
import Overviews from './Overviews';
import SwitchCategory from './SwitchCategory';
import styles from './index.module.scss';

export default function CapabilitiesOverview({ productMenus }: { productMenus: OverseaFeatureItem[]; }) {
  const [activeCategory, setActiveCategory] = useState<number>(productMenus?.[0]?.category_id ?? 0);
  const isClient = useIsClient();

  const handleCategoryClick = (id: number) => {
    setActiveCategory(id);
  };

  const getDisplayStyle = (categoryId: number) => {
    // 服务端渲染时显示全部
    if (!isClient) return 'block';
    // 客户端根据 activeCategory 控制显隐
    return activeCategory === categoryId ? 'block' : 'none';
  };

  return (
    <div>
      <Card style={{ paddingRight: '0px', paddingLeft: '0px' }}>
        <CardHeader style={{ paddingRight: '16px', paddingLeft: '16px' }}>
          <CardGradientText className={styles.cardGradientText}>
            Capabilities Overview
          </CardGradientText>
          <CardTitle>Everything you need to create viral content at scale</CardTitle>
        </CardHeader>
        <CardContent className={styles.overviewsContainer} style={{ paddingLeft: '16px' }}>
          <SwitchCategory productMenus={productMenus} activeCategory={activeCategory} handleCategoryClick={handleCategoryClick} />
          {productMenus?.map((category) => (
            <div
              key={category.category_id}
              style={{ display: getDisplayStyle(category.category_id) }}
            >
              <Overviews categorys={category.list || []} />
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
